import { c as _c } from "react/compiler-runtime";
import { Button, HStack } from '@chakra-ui/react';
import { useOnboardingContext } from '@src/components/sco/Onboarding/Layout/OnboardingContext';
import { ChevronRightIcon } from '@src/components/sco/icons';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { useRouter } from 'next/navigation';
import React from 'react';
type OnboardingStepNavProps = {
  onNext?: () => any;
};
export const OnboardingStepNav = props => {
  const $ = _c(15);
  const {
    activeContainerWidth
  } = useBreakpointContext();
  const [isLoading, setIsLoading] = React.useState(false);
  const onboardingContext = useOnboardingContext();
  const router = useRouter();
  const t0 = activeContainerWidth || "full";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["sm", "sm", "md", "lg"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onboardingContext.nextStepHref || $[2] !== props || $[3] !== router) {
    t2 = async ev => {
      if (props.onNext) {
        ev.preventDefault();
        setIsLoading(true);
        await props.onNext();
        router.push(onboardingContext.nextStepHref);
      }
    };
    $[1] = onboardingContext.nextStepHref;
    $[2] = props;
    $[3] = router;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ChevronRightIcon />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onboardingContext.nextStepHref || $[7] !== t2) {
    t4 = <NextLink href={onboardingContext.nextStepHref} onClick={t2}>Continue{t3}</NextLink>;
    $[6] = onboardingContext.nextStepHref;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== isLoading || $[10] !== t4) {
    t5 = <Button asChild={true} loading={isLoading} size={t1} variant="cta">{t4}</Button>;
    $[9] = isLoading;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t0 || $[13] !== t5) {
    t6 = <HStack backdropFilter="blur(10px)" bgColor="colorPalette.bg/90" bottom="0" justify="end" padding="1em" position="sticky" width={t0}>{t5}</HStack>;
    $[12] = t0;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};